import { Checkbox } from "@shared/ui/Checkbox";
import { Flex } from "antd";
import classNames from "classnames";

type TableRowCheckboxCellProps<T extends { _id: string }> = {
  record: T;
  checkedList: string[];
  selectedRows: T[];
  setCheckedList: (keys: string[]) => void;
  setSelectedRows: (rows: T[]) => void;
  checkboxClassName?: string;
};

export function TableRowCheckboxCell<T extends { _id: string }>({
  record,
  checkedList,
  selectedRows,
  setCheckedList,
  setSelectedRows,
  checkboxClassName,
}: TableRowCheckboxCellProps<T>) {
  return (
    <Flex
      align="center"
      justify="center"
      style={{ width: "100%", height: "100%" }}
    >
      <Checkbox
        id={record._id}
        checked={checkedList.includes(record._id)}
        onChange={(event) => {
          if (event.target.checked) {
            setCheckedList([...checkedList, record._id]);
            setSelectedRows([...selectedRows, record]);
          } else {
            setCheckedList(checkedList.filter((key) => key !== record._id));
            setSelectedRows(
              selectedRows.filter((row) => row._id !== record._id)
            );
          }
        }}
        className={classNames(checkboxClassName)}
      />
    </Flex>
  );
}

type TableRowCheckboxHeaderProps<T extends { _id: string }> = {
  rows: T[];
  checkedList: string[];
  clearSelection: () => void;
  setCheckedList: (keys: string[]) => void;
  setSelectedRows: (rows: T[]) => void;
};

export function TableRowCheckboxHeader<T extends { _id: string }>({
  rows,
  checkedList,
  clearSelection,
  setCheckedList,
  setSelectedRows,
}: TableRowCheckboxHeaderProps<T>) {
  return (
    <Checkbox
      checked={rows.length !== 0 && checkedList.length === rows.length}
      indeterminate={
        checkedList.length !== 0 && checkedList.length < rows.length
      }
      disabled={rows.length === 0}
      onChange={(event) => {
        if (event.target.checked) {
          setCheckedList(rows.map((row) => row._id));
          setSelectedRows(rows);
        } else {
          clearSelection();
        }
      }}
    />
  );
}

export function renderTableRowCheckboxCell<T extends { _id: string }>(
  props: TableRowCheckboxCellProps<T>
) {
  return <TableRowCheckboxCell {...props} />;
}

export function renderTableRowCheckboxHeader<T extends { _id: string }>(
  props: TableRowCheckboxHeaderProps<T>
) {
  return <TableRowCheckboxHeader {...props} />;
}
